export const TYPE_TEXT_MAP: Record<string, string> = {
  FILE_UPLOAD: 'File Upload',
  WEBSITE_LOGIN: 'Website Login',
  EXTERNAL_ACTION: 'External Action',
  AUDIO_RECORDING: 'Audio Recording',
  VOICE_CONVERSATION: 'Voice Conversation',
  PROFILE: 'Survey',
  STAKING: 'Stake SOL',
  PROFICIENCY_ASSESSMENT: 'Proficiency Assessment'
}

export type MissionField = {
  id: string
  type: 'number' | 'select' | 'checkbox' | 'radio' | 'file' | 'photo'
  name: string
  description: string
  placeholder?: string
  valueSource?: 'dictionary:language' | 'dictionary:languageLevel' | 'dictionary:country'
  options?: { value: string; label: string }[]
}

export type Mission = {
  availability: {
    available: boolean
    reason: 'unavailable' | 'profile_required' | undefined
  }
  id: string
  sortOrder: number
  title: string
  status: 'ENABLED' | 'DISABLED' | 'ENDED'
  reward: number
  shortDescription: string
  tags: string[]
  description: {
    sections: {
      name: string
      body: string
      image: string
    }[]
  }
  detailPath?: string
  view: {
    accruedReward: number
    joined: number
    latestSubmissionStatus: null | 'IN_PROGRESS' | 'SUBMITTED' | 'COMPLETED' | 'FAILED'
    nextSubmissionAvailable: boolean
    nextSubmissionReward: number
    tooltip?: string
  }
} & (
  | {
      type: 'WEBSITE_LOGIN'
      view: {
        earnedPoints: number
        executedJobs: number
        multiplier: number
      }
    }
  | {
      type: 'FILE_UPLOAD'
      view: {
        uploadedBytes: number
        buttonText?: string
        fields?: MissionField[]
      }
    }
  | {
      type: 'EXTERNAL_ACTION'
    }
  | {
      type: 'AUDIO_RECORDING'
    }
  | {
      type: 'VOICE_CONVERSATION'
    }
  | {
      type: 'STAKING'
    }
  | {
      type: 'PROFILE'
    }
  | {
      type: 'PROFICIENCY_ASSESSMENT'
    }
)
